import { useState } from "react";
import "./Card.css"


function Card() {
    const [range, setRange] = useState(2);
    const prices = [
                    8.00,
                    12.00,
                    16.00,
                    24.00,
                    36.00
                 ];

    const views = [ 
        '10K pageviews', 
        '50K pageviews',
        '100K pageviews',
        '500k pageviews',
        '1M pageviews'
    ];

    const [checked, setChecked] = useState(false); 
    const handleChange = () => { 
    
    setChecked(!checked); 
    
  }; 

  return (

    <div className="Container">
        <div className="mainTitle">
            <h1>Simple, traffic-based pricing</h1>
            <p className="signContent">Sign-up for our 30-day trial. No credit card required.</p>
        </div>
        <div className="cardLayout">
          
            <div className="price-container">
                <div className="views">
                    {views[range]}
                </div>
                <div className="perMonth desktop">
                    <div className="priceTag">{'$' + ((prices[range]) * (checked ? 0.75 : 1)).toFixed(2)}</div>
                    <div className="month"> / month</div>
                </div>
            </div>

          <div className="sliderPrice">
              <input id="myRange" className="slider" type="range" step="1"
              min='0' max='4'
              defaultValue='2'
              onChange = {(event) => setRange(event.target.value)}
              />
          </div>
            
                <div className="perMonth mobile smallSize">
                    <div className="priceTag">{'$' + ((prices[range]) * (checked ? 0.75 : 1)).toFixed(2)}</div>
                    <div className="month"> / month</div>
                </div>
           
          <div className="switcher-container">
                
                <div>Monthly Billing</div>
                <label className="switch">
                <input type="checkbox" 
                onChange={handleChange}
                />
                <span className="switcher round"></span>
                </label>
                <div>Yearly Billing</div>
                <div className="discount desktop">25% discount</div>
                <div className="discount mobile">-25%</div>
            </div>
          
            <hr />


            <div className="bottomContent">

                <div className="checks">
                    <div>
                        <img src={require('../../icon-check.svg').default} alt="check icon"/>
                        Unlimited websites
                    </div>
                    <div>
                        <img src={require('../../icon-check.svg').default} alt="check icon"/>
                        100% data ownership
                    </div>
                    <div>
                        <img src={require('../../icon-check.svg').default} alt="check icon"/>
                        Email reports
                    </div>

                    

                </div>

                <div>
                    <button className="trialBtn">Start my trial</button>
                    </div>

            </div>
        </div>
    </div>
  )
}

export default Card